import Store from '@/store';

export default function (to, from, next) {
  if (Store.getters['auth/authenticated']) {
    return next({
      name: 'home',
    });
  }
  return next();
}
